const joinObjectByColin = ([key, value]) => {
  return `${key}:${value}`;
};

const pushAttributeByDomain = (section) => {
  return ([key, value] = []) => {
    window.newrelic.setCustomAttribute(`${section}_${key}`, value);
  };
};

const extractHostname = (url = '') => {
  let hostname;

  if (url.indexOf('//') > -1) {
    hostname = url.split('/')?.[2];
  } else {
    hostname = url.split('/')?.[0];
  }
  hostname = hostname.split(':')?.[0];
  hostname = hostname.split('?')?.[0];

  return hostname;
};

const domainReducer = (acc, item) => {
  const domain = extractHostname(item?.src);
  if (/([--:\w?@%&+~#=]*\.[a-z]{2,4}\/{0,2})((?:[?&](?:\w+)=(?:\w+))+|[--:\w?@%&+~#=]+)?/gi.test(domain)) {
    if (acc?.[domain]) {
      acc[domain] += 1;
    } else {
      acc[domain] = 1;
    }
  }
  return acc;
};

export const staticAssets = () => {
  if (typeof window !== 'undefined') {
    // eslint-disable-next-line no-unused-expressions
    window.addEventListener('load', () => {
      setTimeout(() => {
        const images = document.querySelectorAll('img');
        const js = document.querySelectorAll('script');
        const buttons = document.querySelectorAll('button');
        const links = document.querySelectorAll('link');

        const buttonsWithImages = Array.from(buttons)?.filter((button) => {
          return button?.style?.backgroundImage;
        })?.map((button) => {
          return { src: button?.style?.backgroundImage?.replace('url("', '')?.replace('")', '') };
        });

        const cssLinks = Array.from(links)?.filter((link) => {
          return link?.rel === 'stylesheet';
        })?.map((link) => {
          return { src: link?.href };
        });

        const { imageList, trackingPixelList } = Array.from(images).reduce((acc, image) => {
          if (image?.naturalWidth > 0 && image?.naturalHeight > 0) {
            acc.imageList.push(image);
          } else {
            acc.trackingPixelList.push(image);
          }
          return acc;
        }, { imageList: [], trackingPixelList: [] });

        const imageDomains = [...imageList, ...buttonsWithImages].reduce(domainReducer, {});
        const trackingPixelDomains = trackingPixelList.reduce(domainReducer, {});
        const cssDomains = Array.from(cssLinks).reduce(domainReducer, {});
        const jsDomains = Array.from(js).reduce(domainReducer, {});

        // NR Solution #1
        const imageCountByDomain = Object.entries(imageDomains).map(joinObjectByColin).join('|');
        const trackingPixelCountByDomain = Object.entries(trackingPixelDomains).map(joinObjectByColin).join('|');
        const cssCountByDomain = Object.entries(cssDomains).map(joinObjectByColin).join('|');
        const jsCountByDomain = Object.entries(jsDomains).map(joinObjectByColin).join('|');

        window.newrelic.setCustomAttribute('NucleusImageCountByDomain', imageCountByDomain);
        window.newrelic.setCustomAttribute('NucleusTotalImagesLoaded', [...imageList, ...buttonsWithImages].length);

        window.newrelic.setCustomAttribute('NucleusTrackingPixelCountByDomain', trackingPixelCountByDomain);
        window.newrelic.setCustomAttribute('NucleusTotalTrackingPixelsLoaded', trackingPixelList?.length);

        window.newrelic.setCustomAttribute('NucleusCssCountByDomain', cssCountByDomain);
        window.newrelic.setCustomAttribute('NucleusTotalCssLoaded', cssLinks?.length);

        window.newrelic.setCustomAttribute('NucleusJsCountByDomain', jsCountByDomain);
        window.newrelic.setCustomAttribute('NucleusTotalJsLoaded', js?.length);

        // NR Solution #2
        Object.entries(imageDomains).forEach(pushAttributeByDomain('NucleusImages'));
        Object.entries(trackingPixelDomains).forEach(pushAttributeByDomain('NucleusTrackingPixels'));
        Object.entries(cssDomains).forEach(pushAttributeByDomain('NucleusCss'));
        Object.entries(jsDomains).forEach(pushAttributeByDomain('NucleusJs'));

      }, 500);
    });
  }
};
